import { GlobalWorkerOptions } from 'pdfjs-dist';
// Vite 전용 — 워커 파일을 Vite 자산 파이프라인으로 서빙하고 최종 URL을 준다.
// `new URL(bare, import.meta.url)` 로 바꿔 봤더니 브라우저(Vite dev 서버)에서
// 워커 스크립트 요청이 그냥 pending 으로 멈춰(실제로 겪음 — page.render() 가
// 영원히 안 끝남) `?url` 이 실제로는 맞는 방법이었다. Node 테스트 러너에서
// 이 파일의 import 가 깨지는 문제는 여기서 고치지 않는다 — 이 파일(과 reader.ts/
// attach.ts)은 항상 동적 import() 뒤에서만 불러오도록(uploadRepo.ts 참고)
// 감싸서 테스트 그래프에 정적으로 얽히지 않게 한다.
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

/** reader.ts/attach.ts 양쪽에서 쓰는 pdfjs 워커 설정 — 한 곳에서만 한다. */
GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

/**
 * pdfjs 는 전용 Web Worker 로 실제 파싱을 한다 — 그 워커 스크립트 로드가
 * 막히면(네트워크·CSP·프록시 등) 관련 Promise 가 **영원히** 안 끝난다(pdfjs
 * 자체엔 이 경로에 타임아웃이 없다). 그래서 사용자가 스피너에 무한히
 * 갇히지 않도록 reader.ts/attach.ts 양쪽에서 이 헬퍼로 감싼다.
 */
export function withTimeout<T>(p: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = window.setTimeout(
      () => reject(new Error(`${label} 이 시간 안에 끝나지 않았습니다.`)),
      ms
    );
    p.then(
      (v) => {
        window.clearTimeout(timer);
        resolve(v);
      },
      (e) => {
        window.clearTimeout(timer);
        reject(e);
      }
    );
  });
}
